import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { plus1ogy4liedzq5j as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { get_indices3txodfl5wuu5j as get_indices } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  last1vo29oleiqj36 as last,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ListClass;
function List() {
  if (ListClass === VOID) {
    class $ extends State() {
      constructor(list) {
        super();
        this.z4g_1 = list;
      }
      toString() {
        return 'List (' + this.z4g_1.q2() + ')';
      }
    }
    initMetadataForClass($, 'List');
    ListClass = $;
  }
  return ListClass;
}
var MapClass;
function Map() {
  if (MapClass === VOID) {
    class $ extends State() {
      constructor(map, name) {
        super();
        this.a4h_1 = map;
        this.b4h_1 = name;
      }
      toString() {
        return 'Map (' + this.b4h_1 + ')';
      }
    }
    initMetadataForClass($, 'Map');
    MapClass = $;
  }
  return MapClass;
}
var StateClass;
function State() {
  if (StateClass === VOID) {
    class $ {}
    initMetadataForClass($, 'State');
    StateClass = $;
  }
  return StateClass;
}
function mergeWith($this, $receiver, other) {
  if ($receiver == null) {
    return other;
  }
  if (other == null) {
    return $receiver;
  }
  var tmp;
  if (isInterface($receiver, KtList())) {
    // Inline function 'kotlin.check' call
    if (!isInterface(other, KtList())) {
      var message = 'Cannot merge ' + toString($receiver) + ' with ' + toString(other);
      throw IllegalStateException().o(toString(message));
    }
    // Inline function 'kotlin.check' call
    if (!($receiver.q2() === other.q2())) {
      var message_0 = 'Cannot merge ' + toString($receiver) + ' with ' + toString(other);
      throw IllegalStateException().o(toString(message_0));
    }
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_indices($receiver);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().h2(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.q3_1;
    var last = this_0.r3_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var i = item;
        var tmp$ret$6 = mergeWith($this, $receiver.r2(i), other.r2(i));
        destination.i2(tmp$ret$6);
      }
       while (!(item === last));
    tmp = destination;
  } else {
    if (isInterface($receiver, KtMap())) {
      // Inline function 'kotlin.check' call
      if (!isInterface(other, KtMap())) {
        var message_1 = 'Cannot merge ' + toString($receiver) + ' with ' + toString(other);
        throw IllegalStateException().o(toString(message_1));
      }
      if (!isInterface($receiver, KtMap()))
        THROW_CCE();
      if (!isInterface(other, KtMap()))
        THROW_CCE();
      // Inline function 'kotlin.collections.map' call
      var this_1 = plus($receiver.v4(), other.v4());
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList().h2(collectionSizeOrDefault(this_1, 10));
      var _iterator__ex2g4s = this_1.p1();
      while (_iterator__ex2g4s.q1()) {
        var item_0 = _iterator__ex2g4s.r1();
        var tmp$ret$11 = to(item_0, mergeWith($this, $receiver.u4(item_0), other.u4(item_0)));
        destination_0.i2(tmp$ret$11);
      }
      tmp = toMap(destination_0);
    } else {
      // Inline function 'kotlin.check' call
      if (!equals($receiver, other)) {
        // Inline function 'kotlin.error' call
        var message_2 = 'Cannot merge ' + toString($receiver) + ' with ' + toString(other);
        throw IllegalStateException().o(toString(message_2));
      }
      tmp = $receiver;
    }
  }
  return tmp;
}
function valueInternal($this, value) {
  // Inline function 'kotlin.apply' call
  var state = lastOrNull($this.k42_1);
  if (state instanceof Map()) {
    var name = state.b4h_1;
    // Inline function 'kotlin.check' call
    if (!!(name == null)) {
      throw IllegalStateException().o('Check failed.');
    }
    if (state.a4h_1.s4(name)) {
      var tmp0 = state.a4h_1;
      // Inline function 'kotlin.collections.set' call
      var value_0 = mergeWith($this, state.a4h_1.u4(name), value);
      tmp0.x4(name, value_0);
    } else {
      // Inline function 'kotlin.collections.set' call
      state.a4h_1.x4(name, value);
    }
    state.b4h_1 = null;
  } else {
    if (state instanceof List()) {
      state.z4g_1.i2(value);
    } else {
      $this.i42_1 = value;
      $this.j42_1 = true;
    }
  }
  return $this;
}
var MapJsonWriterClass;
function MapJsonWriter() {
  if (MapJsonWriterClass === VOID) {
    class $ {
      constructor() {
        this.i42_1 = null;
        this.j42_1 = false;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.k42_1 = ArrayList().p2();
      }
      l42() {
        // Inline function 'kotlin.check' call
        if (!this.j42_1) {
          throw IllegalStateException().o('Check failed.');
        }
        return this.i42_1;
      }
      n42() {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.collections.mutableListOf' call
        var list = ArrayList().p2();
        this.k42_1.i2(new (List())(list));
        return this;
      }
      o42() {
        // Inline function 'kotlin.apply' call
        var state = this.k42_1.c5(this.k42_1.q2() - 1 | 0);
        // Inline function 'kotlin.check' call
        if (!(state instanceof List())) {
          throw IllegalStateException().o('Check failed.');
        }
        valueInternal(this, state.z4g_1);
        return this;
      }
      f42() {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.collections.mutableMapOf' call
        var map = LinkedHashMap().ec();
        this.k42_1.i2(new (Map())(map, null));
        return this;
      }
      g42() {
        // Inline function 'kotlin.apply' call
        var state = this.k42_1.c5(this.k42_1.q2() - 1 | 0);
        // Inline function 'kotlin.check' call
        if (!(state instanceof Map())) {
          throw IllegalStateException().o('Check failed.');
        }
        valueInternal(this, state.a4h_1);
        return this;
      }
      k4e(name) {
        // Inline function 'kotlin.apply' call
        var state = last(this.k42_1);
        // Inline function 'kotlin.check' call
        if (!(state instanceof Map())) {
          throw IllegalStateException().o('Check failed.');
        }
        // Inline function 'kotlin.check' call
        if (!(state.b4h_1 == null)) {
          throw IllegalStateException().o('Check failed.');
        }
        state.b4h_1 = name;
        return this;
      }
      a4e() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.k42_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().h2(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp;
          if (item instanceof List()) {
            tmp = item.z4g_1.q2().toString();
          } else {
            if (item instanceof Map()) {
              var tmp1_elvis_lhs = item.b4h_1;
              tmp = tmp1_elvis_lhs == null ? '?' : tmp1_elvis_lhs;
            } else {
              noWhenBranchMatchedException();
            }
          }
          var tmp$ret$2 = tmp;
          destination.i2(tmp$ret$2);
        }
        return joinToString(destination, '.');
      }
      u42(value) {
        return valueInternal(this, value);
      }
      e43(value) {
        return valueInternal(this, value);
      }
      z42(value) {
        return valueInternal(this, value);
      }
      w42(value) {
        return valueInternal(this, value);
      }
      c43(value) {
        return valueInternal(this, value);
      }
      m4e(value) {
        return valueInternal(this, value);
      }
      j43(value) {
        return valueInternal(this, null);
      }
      y41() {
        return valueInternal(this, null);
      }
      l6() {
      }
    }
    initMetadataForClass($, 'MapJsonWriter', MapJsonWriter);
    MapJsonWriterClass = $;
  }
  return MapJsonWriterClass;
}
//region block: exports
export {
  MapJsonWriter as MapJsonWriter4jz7ym6vbwk4,
};
//endregion

//# sourceMappingURL=MapJsonWriter.mjs.map
